// HowStudentDoing.tsx

import { useState } from "react";
import BarChart from "../../Charts/BarChart";
import "./AdminStudentDoing.scss";
import FlagsAndNudgesCard from "./Cards/FlagsAndNudges";
import EmotionalTrendsCard from "./Cards/EmotionalTrends";
import images from "../../../assets/Icons/Icons";
import AverageTimeCard from "../StoriesSnapShot/AvergeTimeCard";
import EmotionalTrendsChart from "./../StoriesSnapShot/EmotionalTrends";
import NoDataScreen from "../../EmptyScreen/EmptyScreen";
import { SectionLoader } from "../../Loader/sectionLoader";
import EmotionalTrends from './Cards/EmotionalTrends';

const HowStudentDoing = ({
  data,
  studentName,
  loading,
}: {
  data: any;
  studentName: string;
  loading?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  const timeStatsData = data?.data?.totalTimeStats;
  const istimeStatsEmpty =
    !timeStatsData || Object.keys(timeStatsData).length === 0;

  const toggleOpen = () => {
    setOpen(!open);
  };

  if (!data) return null;

  return (
    <section className="insight-section">
      <header onClick={toggleOpen} className="section-header">
        <h3>HOW IS {studentName} DOING?</h3>
        <img
          src={open ? images.upIocn : images.downIcon}
          width={44}
          height={44}
        />
      </header>

      {open &&
        (loading ? (
          <SectionLoader />
        ) : (
          <div className="how-cards">
            <div className="emocard">
                 <div className="titles">
                Emotional Trends
              </div>
              <EmotionalTrendsChart chartData={data?.data} />
            </div>

            <div className="emocard">
              <div className="titles">
                Average time to complete stories
              </div>
              {istimeStatsEmpty ? (
                <NoDataScreen />
              ) : (
                <AverageTimeCard data={data?.data?.totalTimeStats} />
              )}
            </div>
          </div>
        ))
        // </div>
      }
    </section>
  );
};

export default HowStudentDoing;
